/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2019 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import React from 'react';

import { defineMessages, injectIntl } from '@nebula/izzy/intl';

import ModalDialog from '@nebula/luna/dist/core/modal-dialog';
import SessionDetailsContent from './session.details.modal.content';

const MSG = defineMessages({
  cancelLabel: {
    id: 'gemini.session.create.cancelLabel',
    defaultMessage: 'Cancel'
  },
  doneLabel: {
    id: 'gemini.session.details.doneLabel',
    defaultMessage: 'Done'
  },
  title: {
    id: 'gemini.session.details.title',
    defaultMessage: 'Session Details'
  }
});
const SessionDetails = ({
  detailsForm,
  izzy,
  link,
  nameField,
  onClose,
  pin,
  urlField,
  ...props
}) => (
  <ModalDialog
    mode="alert"
    title={izzy(MSG.title)}
    cancelLabel={detailsForm.dirty ? izzy(MSG.cancelLabel) : null}
    confirmLabel={izzy(MSG.doneLabel)}
    onCancel={detailsForm.onReset}
    onConfirm={(...a) => (detailsForm.dirty ? detailsForm.onSubmit(...a) : onClose())}
    variant="confirmation"
    {...props}
  >
    <SessionDetailsContent
      detailsForm={detailsForm}
      izzy={izzy}
      link={link}
      nameField={nameField}
      pin={pin}
      urlField={urlField}
      variant="confirmation"
    />
  </ModalDialog>
);

SessionDetails.displayName = 'SessionDetails';

export default injectIntl(SessionDetails);
